import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LineProjectionChartComponent } from './line-projection-chart.component';

@NgModule({
  declarations: [
    LineProjectionChartComponent
  ],
  exports: [
    LineProjectionChartComponent
  ],
  imports: [
    CommonModule,
  ]
})
export class LineProjectionChartModule { }
